import { useConfiguration } from '../../../../../../../../store/configurationStore';
import { ColumnMapping } from '../../../../../types';
import { ColumnMappingProps } from './types';

export const useColumnMapping = (props: ColumnMappingProps) => {
  const {
    templateId,
    instrumentType,
    sectionId,
    availableHeaders,
    singleMode = false,
  } = props;
  const {
    templates,
    activeTemplateId,
    addColumnMapping,
    updateColumnMapping,
    deleteColumnMapping,
  } = useConfiguration();

  // Get the active template
  const activeTemplate = templates.find(t => t.id === activeTemplateId);

  // Get the active instrument config
  const instrumentConfig = activeTemplate?.instrumentConfigs.find(
    ic => ic.instrumentType === instrumentType
  );

  // Get the section by ID
  const columnMappingSection = instrumentConfig?.sections.find(
    section => section.id === sectionId
  );

  // Get column mappings from the section
  const columnMappings = columnMappingSection?.config.columnMappings || [];

  // Use actual file headers
  const availableColumns = availableHeaders;

  // Get available columns for a specific mapping (excluding already selected columns)
  const getAvailableColumnsForMapping = (
    currentMappingId: string
  ): string[] => {
    // Get all selected columns except from current mapping
    const selectedColumns = columnMappings
      .filter(m => m.id !== currentMappingId && m.sourceColumn)
      .map(m => m.sourceColumn);

    // Return available columns that haven't been selected
    return availableHeaders.filter(col => !selectedColumns.includes(col));
  };

  // Handle adding a new column mapping
  const handleAddColumn = (): void => {
    const newColumnMapping: ColumnMapping = {
      id: `col-${Date.now()}`, // Generate unique ID
      sourceColumn: '', // Empty initially - user will select
    };

    addColumnMapping(templateId, instrumentType, sectionId, newColumnMapping);
  };

  // Handle removing a column mapping
  const handleRemoveColumn = (columnId: string): void => {
    deleteColumnMapping(templateId, instrumentType, sectionId, columnId);
  };

  // Handle column selection change
  const handleColumnChange = (
    columnId: string,
    selectedColumn: string
  ): void => {
    updateColumnMapping(templateId, instrumentType, sectionId, columnId, {
      sourceColumn: selectedColumn,
    });
  };

  return {
    columnMappings,
    availableColumns,
    getAvailableColumnsForMapping,
    handleAddColumn,
    handleRemoveColumn,
    handleColumnChange,
    singleMode,
  };
};
